module.exports = __webpack_public_path__ + "static/media/icon_check_circle.dd226c08.svg";